import Component from './home'

export default Component